<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
  body {
    margin: 0;
  }

  #app {
    font-family: ‘宋体’,'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%;
  }

  .el-menu-item span{
    font-size: 16px;
  }

  .el-table .cell {
    white-space:normal;
    word-break:break-word;
    color: #000000;
    padding: 0px 0px 0px 2px;

  }

  .el-table .same-tid {
    /*background: oldlace;*/
    background: #FFFF66;
  }

  .el-table .normal {
    /* background: #FFFF22;*/
  }

  .el-table{
    border-bottom: solid 1px #8cc5ff;
  }
   .el-table td{
     border: solid 1px #8cc5ff;
     padding: 0px 0px;
   }

  td {
    border: solid 0px #8cc5ff;

  }

  .el-table__expanded-cell[class*=cell]{
    padding: 0px 0px 5px 0px;
    background-color: #f0c78a;
  }

  .el-table .lock-row {
    background: #cccccc ;
  }

  .el-table .expand-row {
    background: #f0c78a;
  }

  .el-checkbox__label{
    padding-left: 0px;
    font-size: 10px;
    color: #000;
  }

  .el-input__inner{
    padding: 0px 0px 0px 3px;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #000;
  }

   /*鼠标滑过td上作用的样式，ie6不支持:hover伪类属性，如果是ie6要写成tr.over样式*/
     .el-table tbody tr:hover>td {
       background-color:transparent!important;
     }
  /*// 如果td没有颜色，可以去掉，这里加上保险*/
     .el-table__body tr.hover-row>td {
       background-color: transparent;
     }


  .el-menu-item span {
    font-size: 14px;
  }

  .el-submenu__title{
    height: 45px;
    line-height: 45px;
  }

  .el-submenu .el-menu-item{
    height: 40px;
    line-height: 40px;
  }


  .el-link.el-link--default {
    color: #FFF;
  }

  .link {
    color: #ffffff;
    font-size: 12pt;
    font-weight: bold;
    text-decoration:none;
  }
  .login  a:link{
    color: #ffffff;
    font-size: 12pt;
    font-weight: bold;
    text-decoration:none;
  }
  .login  a:visited{
    color: #ffffff;
    font-size: 12pt;
    text-decoration:none;
  }

  .login a:hover {
    color: #ffffff;
    font-size: 13pt;
    text-decoration:none;
  }

  .login a:active {
    color: #ffffff;
    font-size: 13pt;
    text-decoration:none;
  }
/* 图标设计 https://www.shejidaren.com/8000-flat-icons.html*/
</style>



// WEBPACK FOOTER //
// src/App.vue